import { useEffect, useState } from "react";

type Flash = { level: "warning" | "success" | "danger"; message: string };

type Subscriber = (msg: Flash | null) => void;

let message: Flash | null = null;
const subscribers = new Set<Subscriber>();

export const setFlashMessage = (msg: Flash) => {
  message = msg;
  subscribers.forEach((cb) => cb(msg));
};

export const clearFlashMessage = () => {
  message = null;
  subscribers.forEach((cb) => cb(null));
};

const subscribeToFlashMessages = (cb: Subscriber) => {
  subscribers.add(cb);
  cb(message); // immediately send current message
  return () => {
    subscribers.delete(cb);
  };
};

export const useFlashMessage = () => {
  const [message, setMessage] = useState<Flash | null>(null);

  useEffect(() => {
    const unsubscribe = subscribeToFlashMessages(setMessage);
    return unsubscribe;
  }, []);

  return message;
};
